import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'

const routes = [
  { path: '/', redirect: () => (getToken() ? '/requirements' : '/login') },
  { path: '/login', name: 'Login', component: () => import('@/views/auth/LoginView.vue'), meta: { public: true } },
  { path: '/register', name: 'Register', component: () => import('@/views/auth/RegisterView.vue'), meta: { public: true } },
  { path: '/forgot-password', name: 'ForgotPasswordVerify', component: () => import('@/views/auth/ForgotPasswordVerifyView.vue'), meta: { public: true } },
  { path: '/forgot-password/reset', name: 'ForgotPasswordReset', component: () => import('@/views/auth/ForgotPasswordResetView.vue'), meta: { public: true } },
  { path: '/forgot-password/success', name: 'ForgotPasswordSuccess', component: () => import('@/views/auth/ForgotPasswordSuccessView.vue'), meta: { public: true } },
  { path: '/public-requirements', name: 'PublicRequirementList', component: () => import('@/views/requirement/PublicListView.vue'), meta: { public: true } },
  { path: '/public-requirements/:requirementId', name: 'PublicRequirementDetail', component: () => import('@/views/requirement/PublicDetailView.vue'), props: true, meta: { public: true } },
  { path: '/requirements', name: 'RequirementList', component: () => import('@/views/requirement/ListView.vue') },
  { path: '/requirements/new', name: 'RequirementCreate', component: () => import('@/views/requirement/FormView.vue') },
  { path: '/requirements/:requirementId/edit', name: 'RequirementEdit', component: () => import('@/views/requirement/FormView.vue'), props: true },
  { path: '/requirements/:requirementId', name: 'RequirementDetail', component: () => import('@/views/requirement/DetailView.vue'), props: true },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
